var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import "../components/card.component";
import { DataStore } from "../services/datastore.service";
import { EventBus } from "../services/eventbus.service";
let AppLink = class AppLink extends LitElement {
    constructor() {
        super();
        this.loading = false;
        this.error = undefined;
        this._id = undefined;
        this._gid = undefined;
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
    }
    createRenderRoot() {
        return this;
    }
    firstUpdated() {
        this.loading = true;
        this._id = this.location.params.id;
        this._gid = this.location.params.gid;
        this.datastore
            .fetchLink(this._id, this._gid)
            .then((response) => {
            this.card = response;
        })
            .catch((error) => {
            const e = JSON.parse(error.body);
            this.error = e.errortext;
            if (e.errorcode !== 401 && e.errorcode !== 403) {
                this.eventbus.dispatchError(error);
            }
        })
            .finally(() => (this.loading = false));
    }
    render() {
        return html `
      ${this.loading === true
            ? html `
            <div class="columns is-centered">
              <div class="column has-text-centered mt-4">
                <span class="icon has-text-info fa-2x">
                  <i class="fas fa-spin fa-spinner"></i>
                </span>
              </div>
            </div>
          `
            : html `
            ${this.error === undefined
                ? html `
                  <div class="fade-in columns is-multiline is-centered is-1-mobile is-1-tablet is-3-desktop is-8-widescreen is-2-fullhd">
                    <div class="column is-half">
                      <app-card .card=${this.card} .owner=${this.datastore.user?.id === this.card?.creator} .displayfrom=${true} .displayclip=${true}></app-card>
                    </div>
                  </div>
                `
                : html `
                  <div class="card">
                    <div class="card-content">
                      <p class="subtitle has-text-centered">
                        ${this.error}
                      </p>
                    </div>
                  </div>
                `}
          `}
    `;
    }
};
__decorate([
    property()
], AppLink.prototype, "location", void 0);
__decorate([
    state()
], AppLink.prototype, "loading", void 0);
__decorate([
    state()
], AppLink.prototype, "error", void 0);
AppLink = __decorate([
    customElement("app-link")
], AppLink);
export { AppLink };
//# sourceMappingURL=link.js.map